// extracted by mini-css-extract-plugin
export var anticlockwise = "cg_kB";
export var svg = "cg_ky";
export var wrapper = "cg_h";
export var wrapperFlexCenter = "cg_kz";